import { Injectable } from "@angular/core";
import { AxiosApiClient, TenantDataApi } from "@smallstack/axios-api-client";
import { PageableCrudStore } from "@smallstack/store";
import * as i0 from "@angular/core";
import * as i1 from "@smallstack/axios-api-client";
export class DataStore {
    constructor(axiosApiClient) {
        this.axiosApiClient = axiosApiClient;
        this.cachedStores = {};
    }
    for(featureName, typeName) {
        const storeName = this.getStoreName(featureName, typeName);
        if (this.cachedStores[storeName])
            return this.cachedStores[storeName];
        return (this.cachedStores[storeName] = new DataStoreInternal(this.axiosApiClient, featureName, typeName));
    }
    getStoreName(featureName, typename) {
        return featureName + "_" + typename;
    }
}
DataStore.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: DataStore, deps: [{ token: i1.AxiosApiClient }], target: i0.ɵɵFactoryTarget.Injectable });
DataStore.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: DataStore });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.5", ngImport: i0, type: DataStore, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.AxiosApiClient }]; } });
class DataStoreInternal extends PageableCrudStore {
    constructor(axiosApiClient, featureName, typeName) {
        super();
        this.axiosApiClient = axiosApiClient;
        this.featureName = featureName;
        this.typeName = typeName;
    }
    async loadModels(query) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .getData({ feature: this.featureName, type: this.typeName, ...query });
        return res.data;
    }
    async loadModelById(id) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .getDataById({ id, feature: this.featureName, type: this.typeName });
        return res.data;
    }
    async deleteModelById(id) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .deleteData({ id, feature: this.featureName, type: this.typeName });
        return res.data;
    }
    async deleteModelsByIds(ids) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .deleteManyData({ ids, feature: this.featureName, type: this.typeName });
        return res.data;
    }
    async createModel(model) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .createData({ anyBody: model, feature: this.featureName, type: this.typeName });
        return res.data;
    }
    async patchModel(id, model) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .patchData({ id, anyBody: model, feature: this.featureName, type: this.typeName });
        return res.data;
    }
    async putModel(model) {
        const res = await this.axiosApiClient
            .get(TenantDataApi)
            .putData({ id: model.id, anyBody: model, feature: this.featureName, type: this.typeName });
        return res.data;
    }
}
